import React, { useEffect, useState } from "react";
import styled from "styled-components";
import theme from "../../theme/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRocket, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";

const Wrapper = styled.header`
  width: 100%;
  display: flex;
  gap: 20px;
  align-items: center;
  align-items: center;
  white-space: nowrap;

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 30px;
  }

  .secondaryButtonsContainer {
    display: flex;
    gap: 20px;
  }

  .primaryButton {
    cursor: pointer;
    font-weight: 800;
    font-size: 30px;
    color: ${theme.colors.primaryStrong2X};
  }

  .secondaryButton {
    cursor: pointer;
    color: ${theme.colors.primaryStrong2X};
    font-size: 16px;
    padding-bottom: 5px;
  }

  .active {
    border-bottom: 3px solid ${theme.colors.primary};
  }
`;

const ControlsContainer = ({
  newDashboardData,
  missionControlClick,
  currentActiveTab,
  manageButtonClick,
  newGoalClick,
}) => {
  const dispatch = useDispatch();
  const [uncompletedGoals, setUncompletedGoals] = useState(true);

  useEffect(() => {
    setUncompletedGoals(
      newDashboardData.filter(
        (goal) =>
          goal.ibAccountStatus === "New Account" ||
          goal.ibAccountStatus === null
      )
    );
  }, [dispatch, newDashboardData]);

  return (
    <Wrapper>
      <div className="primaryButton" onClick={missionControlClick}>
        Mission Control
      </div>
      <div className="secondaryButtonsContainer">
        <div
          className={`secondaryButton ${
            currentActiveTab === "manage" ? "active" : ""
          }`}
          onClick={manageButtonClick}
        >
          <FontAwesomeIcon icon={faRocket} /> Manage
        </div>
        {uncompletedGoals.length === 0 && (
          <div className="secondaryButton" onClick={newGoalClick}>
            <FontAwesomeIcon icon={faPlusCircle} /> New Goal
          </div>
        )}
      </div>
    </Wrapper>
  );
};

export default ControlsContainer;
